import React, { useRef, useState } from 'react'
import { Switch, TextField } from '@mui/material'
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import { updateIsOverAndAbove, updateNthOrderSkip, updateNumberOfPurchases, updateOrderResetFrequency } from '../../../../../stateManagement/actions/manageCouponActions';
import { isOnlyDigit } from "../../../services/services";
import CouponBox from '../../CouponBox';
import OrderResetFreq from './OrderResetFreq';
import { useSelector } from 'react-redux';
import { labelMappings } from '../../../utils/utils';
import { ConfirmationPopUp } from '../../../../../components/popup/confirmationPopUp';

function DefineNthPurcase() {
  let {numberOfPurchases:rxNumOfPur , skipNthOrder} = useSelector((state: any) => state?.manageCoupons?.data?.recurrence);
  const {isOverAndAbove} = useSelector((state: any) => state?.manageCoupons?.data);
  
  const [numberOfPurchases, setNumberOfPurchases] = useState(String(rxNumOfPur ?? ""));
  // const [skipStep, setSkipStepPressed] = useState(useSelector((state: any) => (state?.manageCoupons?.data?.recurrence?.skipNthOrder) || false));
  const [errorText, setErrorText] = useState("");
  
  const [openModal , setOpenModal] = useState(false);


  const successMethodRef = useRef(()=>{});

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value.trim().replace(/^0+/, '');
    if (isOnlyDigit(inputValue)) {
      setNumberOfPurchases(inputValue);
      updateNumberOfPurchases(inputValue);
    }
    if (inputValue === "1") {
      setErrorText(labelMappings["nth-order-error"]);
    }
    else {
      setErrorText("");
    }
  };
  // const handleSkipThisStep = () => {
  //   if (skipStep) {
  //     setSkipStepPressed(false);
  //     setOpen(true);
  //     updateNthOrderSkip(false);
  //   }
  //   else {
  //     setSkipStepPressed(true);
  //     updateNthOrderSkip(true);
  //     setErrorText("");
  //     setNumberOfPurchases("");
  //     updateNumberOfPurchases("");
  //     updateOrderResetFrequency("");
  //   }
  // };


  const handleSwitch = ()=>{
    if(skipNthOrder){
      if(!isOverAndAbove){
        setOpenModal(true);
        successMethodRef.current = ()=>{
          // setOpen(true);
          updateNthOrderSkip(false);
          updateIsOverAndAbove(true)
        }
      }else{
        updateNthOrderSkip(false);
        updateIsOverAndAbove(true);
      }
    }
    else{ 
      setNumberOfPurchases("");
      updateNthOrderSkip(true);
      updateNumberOfPurchases("");
      updateOrderResetFrequency("");
      // setOpen((pre)=>!pre);
    }
   
  }


  return (
    <CouponBox 
      alertMessage={labelMappings["Nth_SWITCH_CLICK_DISABLED_ALERT_MESSAGE"]}
      disabled={skipNthOrder} 
      showBorder={true} 
      open={!skipNthOrder}
      collapsible 
      
      header={<>
        <CouponConfigurableLabel text={'define-nth-purchase'} style={{ color: 'inherit' }}
        />
        <span onClick={(e) => e.stopPropagation()}>
          <Switch
            onChange={handleSwitch}
            checked={!skipNthOrder}
          />
        </span>
      </>}>
      <div className='applicable-slab-single-field' style={{ display: 'flex', alignItems: 'center',marginBottom:'11px'
      }}>
        <div className="applicable-slab-single-field-left" style={{ width: '30%', margin: "10px" }}>
          <p style={{ color: '#989898', fontSize: '14px', fontWeight: "bold" }}>{labelMappings["num-of-purchases"]}</p>
        </div>
        <TextField
          id="outlined-basic"
          onChange={handleChange}
          value={numberOfPurchases}
          placeholder={labelMappings["recurrence-nth-order-value"]}
          variant="outlined"
          size="small"
          error={errorText !== ""}
          helperText={errorText}
        />
      </div>
      <OrderResetFreq />

      <ConfirmationPopUp
        message={labelMappings["Nth_PURCHASE_OPEN_OVER_AND_ABOVE_POPUP"]}
        openConfirmModal={openModal}
        setOpenConfirmModal={setOpenModal}
        successMethod={successMethodRef.current}
      />
    </CouponBox>
  )
}

export default DefineNthPurcase;